<template >
	<v-card>
        <v-toolbar dark="dark" color="blue-grey darken-3">
            <v-btn class="ml-1" icon="icon" dark="dark" @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Protocolo: {{atendimento}}</v-toolbar-title>
        </v-toolbar>
        <Chat :protocolo="atendimento"></Chat>
    </v-card>
</template>

<script>
  import Chat from '../pxtalk/Chat'
  export default {
    components: {
        Chat
    },
    props:["atendimento"],
    methods:{
      ouvir()
      {
        //console.log("ouvir")
      }
    }
  }
</script>


<style lang="stylus" >
	.chat
		width 100%
		height calc(100vh - 65px)
		display flex
		flex-direction:column
		background url('https://storage.googleapis.com/gweb-uniblog-publish-prod/images/Background.max-2800x2800.jpg') fixed
		background-size 400px
		background-position center

	.conversas-content
		overflow-y auto
		height 100%
		padding 20px
		box-sizing border-box


	.msgCenter
		width 500px
		padding 5px !important
		color #3d3d3d !important
		text-align center
		background-color #F0F4C3
		margin auto
		margin-top 200px !important

	.msgRight
		width 300px
		float right
		position: relative
		background-color #EF5350
		&:after
			content ''
			position absolute
			right 0
			top 50%
			width 0
			height 0
			border 12px solid transparent
			border-left-color #EF5350
			border-right 0
			margin-top -12px
			margin-right -12px

	.msgLeft
		width 300px
		float left
		position relative
		background-color #00B8D4
		&:after
			content ''
			position absolute
			left 0
			top 50%
			width 0
			height 0
			border 12px solid transparent
			border-right-color #00B8D4
			border-left 5px
			margin-top -12px
			margin-left -12px


	.mensagem
		padding 20px
		display block
		color #fff
		margin-bottom 10px
		clear both
		border-radius .8em
		box-shadow 3px 3px 3px silver

</style>



// WEBPACK FOOTER //
// src/components/user/modais/ConversaHistorico.vue